import Accordion from '@pcln/accordion'
import styled from 'styled-components'
import { Flex, getPaletteColor, Box } from 'pcln-design-system'
import { Calendar } from 'pcln-icons'

export const CalendarIcon = styled(Calendar)`
  border: 6px solid ${getPaletteColor('background.lightest')};
  border-radius: 50%;
`

export const StyledAccordionTrigger = styled(Accordion.Trigger)`
  position: absolute !important;
  right: ${({ theme }) => theme.space[0]}px;
  border-radius: 100%;
  padding: ${({ theme }) => theme.space[2]}px;
`

export const TriggerWrapper = styled(Box)`
  &:hover ${StyledAccordionTrigger} {
    background-color: ${getPaletteColor('background.base')} !important;
  }
  &:hover ${StyledAccordionTrigger} Svg {
    color: ${getPaletteColor('primary.dark')} !important;
  }
`

export const ParentFlex = styled(Flex)`
  position: relative;
`
